export default "__VITE_ASSET__CiNB5GpZ__"